import styled from 'styled-components'

import { Dot } from './Dot'

export const ActivityIndicator = styled.span.attrs({
	children: [<Dot key={0} offset={0} />, <Dot key={1} offset={1} />, <Dot key={2} offset={2} />],
})`
	display: inline-flex;
`
